import { FormikContextType, getIn } from 'formik';
import { ErrorMessage } from 'shared/styles';

export const getFieldError = <T,>(
  formik: FormikContextType<T>,
  fieldName: string
): JSX.Element | null => {
  const error = getIn(formik.errors, fieldName);
  const touched = getIn(formik.touched, fieldName);

  if (touched && error) {
    if (Array.isArray(error)) {
      const filteredErrors = error.filter(Boolean);
      if (filteredErrors.length) {
        return <ErrorMessage>{filteredErrors.join(', ')}</ErrorMessage>;
      }
      return null;
    }
    return <ErrorMessage>{error}</ErrorMessage>;
  }

  return null;
};
